export { default } from "./GeneralTab";
